import routes from "web/routes/constants"
import { RecordViewList } from "web/components"
import Tile from "../Tile/Tile"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "./TileSummarySettingsModal"

export default function ComparableDealSummaryTile({
  overview,
  isTemplate,
  canEdit,
  tileFetchParams,
  isDoubleColumn,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  function goToDeal(deal) {
    window.Turbo.visit(routes.deal("all", null, deal.id)) // cannot guarantee deal exists in
  }

  return (
    <Tile
      canEdit={canEdit}
      title={tile.name}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
    >
      <RecordViewList
        data={tile.data ? [tile.data] : []}
        fields={tile.fields}
        fieldActions={{ name: goToDeal }}
        emptyMessage="There are no comparables for this deal."
        showDummyData={isTemplate}
        isDoubleColumn={isDoubleColumn}
      />

      {!isTemplate && (
        <div>
          <a
            href={`${window.location.pathname}/comparables/${tile.comparables_path}`}
            data-turbo-frame="_top"
            className="p-2.5 text-primary-4 hover:text-feature-6"
          >
            List
            {tile.data?.summarizable_count > 0 &&
              ` (${tile.data.summarizable_count}) `}
          </a>{" "}
          &#8226;{" "}
          <a
            href={`${window.location.pathname}/comparables/${tile.comparables_path}/compare`}
            data-turbo-frame="_top"
            className="p-2.5 text-primary-4 hover:text-feature-6"
          >
            Compare
          </a>
          &nbsp;&#8226;&nbsp;
          <a
            href={`${window.location.pathname}/comparables/${tile.comparables_path}/map`}
            data-turbo-frame="_top"
            className="p-2.5 text-primary-4 hover:text-feature-6"
          >
            Map
          </a>
        </div>
      )}
    </Tile>
  )
}
